/**
 * @generated SignedSource<<fef39ce907fdba15bf55a06287fec533>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type helpersIsArchiveWallArticle$data = {
  readonly createdDate: number | null | undefined;
  readonly paywallTypes: ReadonlyArray<{
    readonly entityId: string;
  } | null | undefined> | null | undefined;
  readonly publishedDate: number | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"helpersIsVelocityWallArticle">;
  readonly " $fragmentType": "helpersIsArchiveWallArticle";
};
export type helpersIsArchiveWallArticle$key = {
  readonly " $data"?: helpersIsArchiveWallArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpersIsArchiveWallArticle">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "helpersIsArchiveWallArticle"
};

(node as any).hash = "8944a7dd2542cb2dc7bb7bc8c2236943";

export default node;
